import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import ViewEnquiryComp from "./Component/ViewEnquiryComp"

const ViewEnquiry =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewEnquiryComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewEnquiry